<template>
  <div id="twitters">
    <h1 id ="widget__text"> みんなの投稿</h1>
    <div id="widget__container">
      <Timeline id="Q18807506" sourceType="profile" :options="{'height': 450}"/>
    </div>
  </div>
</template>

<script>

  import { Tweet, Moment, Timeline } from 'vue-tweet-embed'
  export default{
    components: {
      'Timeline': Timeline,
    },
    data() {
      return {
      }
    },
  }
</script>

<style scoped>
  #widget__container{
    margin: 0px 0px 35px 0px;
    display: -webkit-flex;
    display: flex;
    -webkit-align-items: center; /* 縦方向中央揃え（Safari用） */
    align-items: center; /* 縦方向中央揃え */
    -webkit-justify-content: center; /* 横方向中央揃え（Safari用） */
    justify-content: center; /* 横方向中央揃え */
  }
  #widget__text{
    margin: 50px 20px 20px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Twitter.vue